import colors from '@/constants/Colors';

export const VIEWABLE_ORDER_STATES = ['complete', 'pending', 'pending_payment', 'requested', 'waiting', 'refunded', 'partially_refunded']

export const ORDER_STATES = {
    
    'reserved' : {
        key: 'orders.states.reserved',
        icon: {
            name: 'order-reserved',
            color: '#737373',
            
        }
    },
    
    'complete' : {
        key: 'orders.states.complete',
        icon: {
            name: 'circle-check',
            color: colors.green[500],
        }
    },

    'waiting' : {
        key: 'orders.states.waiting',
        icon: {
            name: 'hourglass-o',
            color: colors.orange[500],
        }
    },

    'pending' : {
        key: 'orders.states.pending',
        icon: {
            name: 'order-waiting',
            color: '#737373',
        }
    },

    'requested' : {
        key: 'orders.states.requested',
        icon: {
            name: 'fa-duotone fa-clock',
            color: '#737373',
        }
    },
    
    
    'pending_payment' : {
        key: 'orders.states.pending_payment',
        icon: {
            name: 'order-payment',
            color: '#fb923c',
        }
    },
    
    'canceled' : {
        key: 'orders.states.canceled',
        icon: {
            name: 'order-canceled',
            color: '#dc2626',
        }
    },
    
    'refunded' : {
        key: 'orders.states.refunded',
        icon: {
            name: 'order-returned',
            color: '#57534e',
        }
    },
    
    'partially_refunded' : {
        key: 'orders.states.partially_refunded',
        icon: {
            name: 'order-returned',
            color: '#fb923c',
        }
    },
    
    'failed' : {
        key: 'orders.states.failed',
        icon: {
            name: 'order-notice',
            color: '#dc2626',
        }
    },
    
    'rejected' : {
        key: 'orders.states.rejected',
        icon: {
            name: 'order-canceled',
            color: '#dc2626',
        }
    },
};
